export default __webpack_public_path__ + "static/media/logo-dark.d794f200.png";